/* Kossik ks2 — beúszás, számlálók, GYIK-fülek, termékkép-címkék. Egyszer fut, akárhány szekció tölti be. */
(function () {
  if (window.__ks2) return; window.__ks2 = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function count(el) {
    var to = parseInt(el.getAttribute('data-ks2-count'), 10) || 0;
    if (reduce) { el.textContent = to + '%'; return; }
    var t0 = null, dur = 1400;
    function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur); var e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(to * e) + '%'; if (p < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  function seen(el) {
    el.classList.add('is-in');
    el.querySelectorAll('[data-ks2-count]').forEach(count);
  }
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.ks2-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(seen); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { seen(e.target); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  function initTabs(root) {
    (root || document).querySelectorAll('[data-ks2-tabs]').forEach(function (box) {
      if (box.__ks2) return; box.__ks2 = true;
      var btns = box.querySelectorAll('[data-ks2-tab]'), items = box.querySelectorAll('[data-ks2-cat]');
      function show(cat) { btns.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-ks2-tab') === cat); });
        items.forEach(function (i) { i.hidden = cat !== '*' && i.getAttribute('data-ks2-cat') !== cat; }); }
      btns.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-ks2-tab')); }); });
      if (btns.length) show(btns[0].getAttribute('data-ks2-tab'));
    });
  }
  function initOverlay() {
    var tpl = document.querySelector('.ks2-ov[data-ks2-tpl]'); if (!tpl) return;
    var media = document.querySelector('[id$="__main-product"] .product__media'); if (!media || media.querySelector('.ks2-ov:not([data-ks2-tpl])')) return;
    var ov = tpl.cloneNode(true); ov.removeAttribute('data-ks2-tpl'); media.appendChild(ov);
  }
  function initScrollLinks() {
    document.querySelectorAll('[data-ks2-to-form]').forEach(function (a) {
      a.addEventListener('click', function (ev) { var f = document.querySelector('[id$="__main-product"] kaching-bundles-block, [id$="__main-product"] .product-form');
        if (f) { ev.preventDefault(); f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } });
    });
  }
  function initSave() {
    var src = document.querySelector('.ks2-ov[data-ks2-tpl] .save'); if (!src) return;
    var box = document.querySelector('[id$="__main-product"] product-info .product__price'); if (!box) return;
    function put() { var pr = box.querySelector('.price--on-sale'); if (pr && !pr.querySelector('.ks2-save')) { var s = document.createElement('span'); s.className = 'ks2-save'; s.textContent = src.textContent.trim(); pr.appendChild(s); } }
    put(); if (!box.__ks2) { box.__ks2 = true; new MutationObserver(put).observe(box, { childList: true, subtree: true }); }
  }
  function all(root) { initReveal(root); initTabs(root); initOverlay(); initSave(); initScrollLinks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
